


























































































import FilterCard from "@/components/filter/FilterCard.vue";
import FilterCardPagination from "@/components/filter/FilterCardPagination.vue";
import { AssetEnum, AssetRepository } from "@/lib/AssetRepository";
import { IFilterListElement } from "@/lib/interfaces/filter/filterListElement.interface";
import DarkModeHighlightMixin from "@/mixins/DarkModeHighlightMixin.vue";
import { MrfiktivPageFilterElementGen } from "@/services/mrfiktiv/v1/data-contracts";
import { ThgPageFilterElementGen } from "@/services/thg/v1/data-contracts";
import { BasePagination, IPaginationFilterListElement } from "@/store/modules/base-pagination.store";
import { Component, Prop } from "vue-property-decorator";
import Debug from "../components/utility/Debug.vue";

@Component({
  components: {
    FilterCard,
    FilterCardPagination,
    Debug
  }
})
export default class TheLayoutPortalList<T> extends DarkModeHighlightMixin {
  @Prop()
  title!: string;

  @Prop()
  filterList!: IFilterListElement[];

  @Prop()
  loading!: boolean;

  @Prop()
  isLoadingMore!: boolean;

  @Prop()
  getModule!: () => BasePagination<any, any>;

  @Prop({ default: true })
  isPaginated!: boolean;

  selected: T | {} = {}; // hack to prevent console error, set by parent

  get paginationFilterList(): IPaginationFilterListElement[] {
    return this.getModule().filterList;
  }

  get search(): string {
    return this.getModule().search;
  }

  set search(search: string) {
    this.getModule().setSearch(search);
  }

  showMenu = false;

  items = this.paginationList;

  get paginationFilter(): ThgPageFilterElementGen[] | MrfiktivPageFilterElementGen[] {
    return this.getModule().filter;
  }

  set paginationFilter(filter: ThgPageFilterElementGen[] | MrfiktivPageFilterElementGen[]) {
    this.getModule().setFilter(filter);
  }

  get paginationList() {
    return this.getModule().paginationList;
  }

  get totalItems() {
    return this.getModule().totalItems;
  }

  get isLoadAll() {
    return this.getModule().isLoadAll;
  }

  set isLoadAll(value: boolean) {
    this.getModule().setIsLoadAll(value);
  }

  get progress() {
    return (this.paginationList.length / this.totalItems) * 100;
  }

  get emptyDataSrc() {
    return AssetRepository.getAsset(false, AssetEnum.emptyData);
  }

  onFiltered(filteredItems: T[]) {
    this.items = filteredItems;
  }

  loadMore() {
    this.$emit("loadMore");
  }

  refresh() {
    this.$emit("refresh");
  }
}
